import * as React from "react";

const QuestionMark: React.FC = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="20px"
            height="21px"
            viewBox="0 0 20 21"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <title>?</title>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="d-configurator-request-a-quote-prompt" transform="translate(-1105.000000, -960.000000)">
                    <g id="Bottom-Banner" transform="translate(306.000000, 932.000000)">
                        <g transform="translate(19.000000, 5.000000)" id="Payment">
                            <g transform="translate(66.000000, 14.500000)">
                                <g id="?" transform="translate(715.000000, 10.000000)">
                                    <circle id="Oval" stroke="#FFFFFF" strokeWidth="1.5" cx="9" cy="9" r="9"></circle>
                                    <text
                                        id="Phone-Number*-Copy"
                                        fontFamily="Lato-Black, Lato"
                                        fontSize="12"
                                        fontWeight="800"
                                        fill="#FFFFFF"
                                    >
                                        <tspan x="6.354" y="13.5">
                                            ?
                                        </tspan>
                                    </text>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(QuestionMark);
